export default "__VITE_ASSET__CPUZ56ML__"